const items = [
  "Remote Engineering Roles",
  "Design Leadership",
  "Product & Growth",
  "Data & AI",
  "Climate Tech",
  "Creative Direction",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <section data-testid="editorial-marquee" className="border-y border-ink/10 bg-sand-deep py-6 overflow-hidden">
      <div className="animate-marquee flex w-max items-center gap-16 sm:gap-24 pr-16 sm:pr-24">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-16 sm:gap-24 whitespace-nowrap">
            <span className="font-serif italic text-xl sm:text-2xl text-ink/55">{item}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-bronze/60" aria-hidden="true" />
          </span>
        ))}
      </div>
    </section>
  );
}
